import React from "react";
import Sidebar from "./Sidebar";
import TaskLists from "./tasks/TaskLists";

export default function Home() {
  return (
    <>
      <div className="container relative">
        <Sidebar />
        <TaskLists />
      </div>
    </>
  );
}
